var map = {
	"./1/symbol_0.png": "19d7",
	"./1/symbol_1.png": "83cb",
	"./1/symbol_10.png": "b182",
	"./1/symbol_11.png": "c3bc",
	"./1/symbol_12.png": "3739",
	"./1/symbol_2.png": "1c6e",
	"./1/symbol_3.png": "ba83",
	"./1/symbol_4.png": "53dc",
	"./1/symbol_5.png": "81d4",
	"./1/symbol_6.png": "6207",
	"./1/symbol_7.png": "e5a2",
	"./1/symbol_8.png": "355b",
	"./1/symbol_9.png": "d4bb",
	"./2/symbol_0.png": "573a",
	"./2/symbol_1.png": "86e6",
	"./2/symbol_10.png": "021a",
	"./2/symbol_11.png": "b2ed",
	"./2/symbol_12.png": "527a",
	"./2/symbol_2.png": "dced",
	"./2/symbol_3.png": "3e5f",
	"./2/symbol_4.png": "f0f2",
	"./2/symbol_5.png": "e499",
	"./2/symbol_6.png": "35fe",
	"./2/symbol_7.png": "ed13",
	"./2/symbol_8.png": "fee4",
	"./2/symbol_9.png": "a913",
	"./3/symbol_0.png": "e3b7",
	"./3/symbol_1.png": "c9f1",
	"./3/symbol_10.png": "61e4",
	"./3/symbol_12.png": "1c81",
	"./3/symbol_2.png": "12dc",
	"./3/symbol_3.png": "a438",
	"./3/symbol_4.png": "d18a",
	"./3/symbol_5.png": "b0ff",
	"./3/symbol_6.png": "173c",
	"./3/symbol_7.png": "7a1b",
	"./3/symbol_8.png": "2c67",
	"./3/symbol_9.png": "5794",
	"./4/symbol_0.png": "4e65",
	"./4/symbol_1.png": "22a3",
	"./4/symbol_10.png": "0aa1",
	"./4/symbol_12.png": "b3e6",
	"./4/symbol_2.png": "e164",
	"./4/symbol_3.png": "194a",
	"./4/symbol_4.png": "0259",
	"./4/symbol_5.png": "af52",
	"./4/symbol_6.png": "7eb1",
	"./4/symbol_7.png": "735e",
	"./4/symbol_8.png": "436d",
	"./4/symbol_9.png": "aadd",
	"./gold1.png": "0683",
	"./gold2.png": "21df",
	"./gold3.png": "140e",
	"./gold4.png": "3eb4",
	"./lose.png": "bd7b",
	"./silver1.png": "4cc8",
	"./silver2.png": "ef68",
	"./silver3.png": "1d3f",
	"./silver4.png": "e3a0",
	"./slotmachine.png": "698f",
	"./win.png": "3e92"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d4c8";